import { getBusinessProfile } from '../config/business-profiles.js';

const DEFAULT_LABELS = {
  label: 'Praticiens',
  labelSingulier: 'Praticien(ne)',
  labelAjouter: 'Ajouter un praticien',
  assignLabel: 'Qui réalise cette prestation ?',
  assignHint: 'Optionnel. Sélectionnez la personne qui effectue ce soin ou ce cours.',
  emptyListHint: 'Aucun praticien enregistré. Ajoutez votre équipe dans l’onglet Praticiens.',
};

export function getInstructeurLabels(categorie) {
  const profile = getBusinessProfile(categorie);
  const moduleLabels = profile?.modules?.instructeurs;
  if (!moduleLabels) return { ...DEFAULT_LABELS };

  return {
    label: moduleLabels.label || DEFAULT_LABELS.label,
    labelSingulier: moduleLabels.labelSingulier || DEFAULT_LABELS.labelSingulier,
    labelAjouter: moduleLabels.labelAjouter || DEFAULT_LABELS.labelAjouter,
    assignLabel: `Qui réalise cette prestation ?`,
    assignHint: `Optionnel. Sélectionnez ${String(moduleLabels.labelSingulier || 'le praticien').toLowerCase()} assigné(e).`,
    emptyListHint: `Aucun(e) ${String(moduleLabels.labelSingulier || 'praticien').toLowerCase()} enregistré(e). Ajoutez votre équipe dans l’onglet ${moduleLabels.label || 'Praticiens'}.`,
  };
}

export function shouldShowInstructeurFeature(categorie) {
  const profile = getBusinessProfile(categorie);
  return Boolean(profile?.features?.instructeurs);
}

export function formatInstructeurName(instructeur) {
  if (!instructeur) return '';
  const prenom = String(instructeur.prenom || '').trim();
  const nom = String(instructeur.nom || '').trim();
  return [prenom, nom].filter(Boolean).join(' ') || 'Sans nom';
}
